<!-- <button mat-button matTooltip="{{'COMMON.TOOL_TIP.CHANGE_LANGUAGE' | translate}}" class=" nav-notification-icons"
[matMenuTriggerFor]="languages"> <i class="material-icons-outlined icon-color">
language
</i>
</button> -->

<mat-menu #languages="matMenu" xPosition="before">
  @for (language of languages_new; track language; let i = $index) {
    <div
      class="language-wrapper {{ language.value == selectlanguage ? 'background-active' : ''}}">
      <div class="language-wrapper__icon-wrapper">
        <button class="language-wrapper__icon" [ngClass]="colors[i]" (click)="changeLanguage(language.value)"
        mat-mini-fab>{{language.value}}</button>
      </div>
      <div class="language-content" (click)="changeLanguage(language.value)">
        <span class="language-content__user">{{language.name}}</span>
      </div>
    </div>
  }
</mat-menu>